import { Link, useNavigate } from "react-router-dom";

import logoPNG from "images/logo.png";

const LogoLink = ({
  url,
  type,
  goBack,
}: {
  url?: string;
  type?: "simple" | "standard";
  goBack?: boolean;
}) => {
  const navigate = useNavigate();

  const getInnerContent = (type: "simple" | "standard") => (
    <>
      {type === "simple" && <span>❮&nbsp;</span>}
      <img
        className="brand-img"
        src={type === "simple" ? "/favicon.ico" : logoPNG}
        alt="Pathology Watch"
        height="36px"
      />
    </>
  );

  return url ? (
    <Link className="LogoLink" to={url}>
      {getInnerContent(type || "standard")}
    </Link>
  ) : (
    <div
      className="LogoLink"
      onClick={() => {
        goBack && navigate(-1);
      }}
    >
      {getInnerContent(type || "standard")}
    </div>
  );
};

export default LogoLink;
